export enum scoreType {
    Incorrect = '0',
    Correct = '1'
}

export interface answerList {
    scoreType: scoreType;
    answer: string;
}

/**
 * @todo 期貨交易知識認知確認表  Score radio 空物件
 */
export interface FuturesKnowledgeObj {
    index: number;
    question: string;
    answerList: answerList[];
    answer: scoreType | null;
    correctAnswer: scoreType | null;
    correctAnswerResolve: string | null;
    errorMsg: string | null | undefined; //
}

export const GetFuturesKnowledgeObj = (): Array<FuturesKnowledgeObj> => {
    return [
        {
            index: 1,
            question: '為增加盤前資訊透明度，臺灣期貨期交所於盤前委託時段揭露各契約模擬試撮之開盤價、量及試撮後之最佳5檔買賣價量資訊。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 2,
            question: '交易人從事國內、國外期貨交易，其交易制度及風險控管機制會因各國交易所、複委託期貨商或我國期貨商規定而有不同。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 3,
            question: '「一定範圍市價委託」是一種不需指定委託價格，但可將成交價格限制在一定範圍內，可降低成交價格大幅偏離交易人預期之情況。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 4,
            question:
                '價格穩定機制係避免價格異常波動的措施，國、內外期貨交易所之價格穩定機制或有不同，但都無法改變市場價格走勢，價格走勢不符預期的部位仍須注意風險控管。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 5,
            question: '交易人以期貨商所提供之報價資訊為下單之唯一依據，不需進行其他驗證。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Incorrect,
            correctAnswerResolve:
                '交易人應瞭解期貨商所提供之報價資訊係由交易所或資訊廠商所提供，雖得自於一般認為可資信賴之來源，但不保證此等資訊之正確與完整，故交易前仍應自行查證。',
            errorMsg: null
        },
        {
            index: 6,
            question: '期貨市場使用市價委託，成交價格皆會接近委託當時市場價格，無須留意商品流動性。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Incorrect,
            correctAnswerResolve:
                '交易人應瞭解市價委託其成交價格與委託當時揭示之市場成交價格或買賣申報價格間可能產生偏離情形，故交易人應隨時關注市場動態及審慎評估委託單之使用。',
            errorMsg: null
        },
        {
            index: 7,
            question: '期貨商品於到期後將自動轉倉，交易人無須留意期貨商品之到期時間。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Incorrect,
            correctAnswerResolve:
                '交易人應瞭解期貨市場交易中，若是契約到期時，交易人仍持有未沖銷部位，則必須辦理現金結算或實務交割。故請交易人留意各商品契約之到期時間。',
            errorMsg: null
        },
        {
            index: 8,
            question: '交易人從事期貨交易須先繳足原始保證金，且期貨商可視交易人信用狀況及交易性質加收保證金(例如對較不具流動性商品加收保證金)。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 9,
            question:
                '保證金種類分為原始保證金及維持保證金，交易人從事期貨交易負有維持保證金之義務，須隨時注意市場行情變化，當帳戶權益數低於維持保證金時，應補足保證金至原始保證金。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 10,
            question: '交易人應自行計算維持保證金之額度與比例，並負有隨時維持期貨商所訂足額保證金之義務，不須等待期貨商之通知或要求。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 11,
            question: '臺灣期貨期交所股票期貨契約及各類選擇權契約之保證金與指數期貨相同，均為固定金額，於交易時段不會隨市場行情而變動。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Incorrect,
            correctAnswerResolve:
                '交易人應瞭解，期貨契約、股票期貨契約及選擇權契約的保證金金額變動，各有不同規定：\n1.臺灣期貨交易所之期貨契約（股票期貨除外）之保證金，係由期交所訂定並公告，故保證金金額不會隨每日市場價格變動。\n2.臺灣期貨交易所之股票期貨契約之保證金，其計收方式為期貨契約價格×契約乘數×風險價格係數，因此該保證金金額會隨期貨契約價格變動。\n 3.臺灣期貨交易所之選擇權契約只有建立賣方部位才會被要求繳存保證金，其保證金計收方式為權利金市值＋MAXIMUM(A值-價外值, B值)，因此該保證金金額會隨所建部位權利金市值變動。',
            errorMsg: null
        },
        {
            index: 12,
            question:
                '期貨商每日結算作業後，對權益數低於未沖銷部位所需維持保證金之帳戶發出盤後保證金追繳，交易人應於約定時間前，依期貨商保證金追繳通知內容，將應補繳金額補足。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 13,
            question:
                '盤中風險指標低於期貨商約定標準時(例如25%)，期貨商將開始執行代為沖銷作業程序。影響代為沖銷結果的因素眾多，有可能導致代為沖銷結果不如預期，甚至產生超額損失（Overloss），交易人仍應對其沖銷結果負責。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 14,
            question: '盤中風險指標低於期貨商約定標準時(例如25%)，期貨商會開始執行代為沖銷程序，將虧損部位全數沖銷，獲利部位則不會沖銷。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Incorrect,
            correctAnswerResolve:
                '交易人應瞭解當交易人帳戶風險指標低於期貨商約定標準時，期貨商會開始執行代為沖銷作業將期貨交易人所有未平倉部位全數沖銷，惟於盤後交易時段，臺灣期貨交易所指定豁免辦理代為沖銷之商品，期貨商無須執行代為沖銷作業。',
            errorMsg: null
        },
        {
            index: 15,
            question: '交易人持有賣出價外選擇權部位，倘交易標的價格巨幅變動，部位轉為深價內選擇權，保證金可能倍數增加。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 16,
            question: '選擇權契約建立部位後，該部位盤中浮動損益金額會計入權益數中加減。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Incorrect,
            correctAnswerResolve:
                '交易人應瞭解期貨交易帳戶中之「權益數」，係以現金基礎計算，因選擇權契約交易與股票買賣同，僅於建立部位及反向平倉之後才會有現金的流動(權利金)，所建部位在還沒反向平倉以前，該部位之損益於每日結算作業時不會有現金的撥付，因此「權益數」計算式中並無選擇權契約浮動損益項。',
            errorMsg: null
        },
        {
            index: 17,
            question: '交易人從事期貨交易，期貨商應於成交後即作成買賣報告書交付交易人，並應於每月底編製對帳單分送交易人。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        },
        {
            index: 18,
            question: '交易人在期貨商指定之金融機構完成開立存款帳戶後，即可下單委託。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Incorrect,
            correctAnswerResolve:
                '交易人應瞭解交易人於期貨商指定之金融機構完成開立存款帳戶及與期貨商約定後，並將保證金存入「客戶保證金專戶」後才能委託交易。',
            errorMsg: null
        },
        {
            index: 19,
            question: '為了下單方便，交易人可請期貨商代為保管款項、印鑑或存摺。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Incorrect,
            correctAnswerResolve: '交易人應瞭解期貨商從事期貨交易，不得因業務之方便，代交易人保管款項、印鑑或存摺。',
            errorMsg: null
        },
        {
            index: 20,
            question: '交易人從事期貨交易前，應熟悉並瞭解期貨商下單備援平台的操作方式，以做為常用下單交易系統異常時之替代。',
            answerList: [
                { scoreType: scoreType.Correct, answer: '正確' },
                { scoreType: scoreType.Incorrect, answer: '不正確' }
            ],
            answer: null,
            correctAnswer: scoreType.Correct,
            correctAnswerResolve: '此題敘述正確。',
            errorMsg: null
        }
    ];
};
